import DelegationAddFromAllMileagesRequest, {
  DelegationAddFromAllMileagesRequestQueryParams,
} from "./delegation-add-from-all-mileages.request";

const createQueryParams = (
  request: DelegationAddFromAllMileagesRequest,
): DelegationAddFromAllMileagesRequestQueryParams => {
  return {
    address: request.address,
    cardNumber: request.cardNumber,
    companyId: request.companyId,
    dateSince: request.dateSince,
    dateTo: request.dateTo,
    cargoCompanyName: request.cargoCompanyName,
    distanceMax: request.distanceMax,
    distanceMin: request.distanceMin,
    endAddress: request.endAddress,
    humanId: request.humanId,
    midAddress: request.midAddress,
    mileageNumber: request.mileageNumber,
    startAddress: request.startAddress,
    workerName: request.workerName,
    vehicleType: request.vehicleType,
  };
};

const delegationAddFromAllMileagesRequestFactory = {
  createQueryParams,
};

export default delegationAddFromAllMileagesRequestFactory;
